import { globalStore, uiStore } from "../../store/store";
import { MessageData } from "@/subapps/onboarding/types";
import { traverseCanvasDocumentAndToggleSectionVisibilityWithCss } from "@/subapps/onboarding/lib/pages";

import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";

export async function handleIframeMessageFromOnboardingApp(
  event: MessageEvent
) {
  if (event.origin !== window.location.origin) {
    console.warn("Message received from untrusted origin:", event.origin);
    return;
  }

  const message = event.data as MessageData;

  switch (message.type) {
    case "updateGlobalSettingsPerPath":
      globalStore.updateGlobalSettingsPerPath(message.payload);

      await saveToWordPressWithErrorsLoggedToUiStore();
      break;

    case "updateBreakpoint":
      uiStore.changeBreakpoint(message.payload.breakpoint);
      break;

    case "hideHomepageSections":
      traverseCanvasDocumentAndToggleSectionVisibilityWithCss(
        message.payload.nodeIds
      );
      break;

    default:
    // console.warn("Unknown message type:", message);
  }
}
